/** Read-only multiline field for structured evidence sections. */

import { Tooltip } from "@risalabs_frontend_org/oasis-ui-kit";

export interface StructuredEvidenceTextAreaProps {
  id: string;
  label: string;
  value: string;
}

/** Render long evidence content with preserved line breaks and vertical scrolling. */
export function StructuredEvidenceTextArea({
  id,
  label,
  value,
}: StructuredEvidenceTextAreaProps) {
  return (
    <Tooltip
      content={
        <div className="max-h-80 overflow-y-auto whitespace-pre-wrap break-words text-xs leading-5">
          {value}
        </div>
      }
      placement="top"
      delay={150}
      disabled={!value}
      maxWidth={520}
      maxHeight={360}
    >
      <div className="flex w-full flex-col items-start gap-[0.38rem]">
        <label
          htmlFor={id}
          className="text-xs font-normal leading-[1.125rem] text-primaryGray-2"
        >
          {label}
        </label>
        <textarea
          id={id}
          name={id}
          value={value}
          readOnly
          rows={5}
          className="box-border min-h-[7.5rem] max-h-[20rem] w-full resize-y overflow-auto whitespace-pre-wrap rounded border border-primaryGray-14 bg-primaryGray-16 px-4 py-3 text-sm font-normal leading-6 text-primaryGray-2 outline-none"
        />
      </div>
    </Tooltip>
  );
}
